import { render, staticRenderFns } from "./TrainerFormComponent.vue?vue&type=template&id=3d8ab16a"
import script from "./TrainerFormComponent.vue?vue&type=script&lang=js"
export * from "./TrainerFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports